import React, {useState} from "react";
import Box from "@mui/material/Box";
import {PDFViewer} from "@react-pdf/renderer"

import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import classnames from "classnames";
import {PurchaseCustomerDisclosurePDF} from "./DisclosurePDFs/Customer/Purchase/PurchaseCustomerDisclosurePDF";
import {CustomerDisclosurePDF} from "./DisclosurePDFs/Customer/Lease/CustomerDisclosurePDF";
import {useUserContext} from "../../contexts/UserContext";
import {parseGoogleAddressData} from "../../utils/utils";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Autocomplete from "react-google-autocomplete";
import Input from "@mui/material/Input";
import {PurchaseDealerDisclosurePDF} from "./DisclosurePDFs/Dealer/Purchase/PurchaseDealerDisclosurePDF";
import {DealerDisclosurePDF} from "./DisclosurePDFs/Dealer/Lease/DealerDisclosurePDF";
import {BaseModal} from "../../components/BaseModal";



export const PDFModal = ({ isOpen, setIsOpen, dealState, isCustomerPDF, ...props } ) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { profileState } = useUserContext()

    const [customerName, setCustomerName] = useState('')
    const [customerAddress, setCustomerAddress] = useState(null)

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'white',
        boxShadow: 24,
        p: 4,
        borderRadius: '4px',
        width: isTabletOrMobile ? '100vw': '60vw',
        height: isTabletOrMobile ? '75vh': '90vh',
        outline: 'none',
    };

    const pdfDisclosure = () => {
        if (isCustomerPDF) {
            if (dealState.is_purchase) {
                return (<PurchaseCustomerDisclosurePDF
                    dealState={dealState}
                    customerName={customerName}
                    customerAddress={customerAddress}
                    companyName={profileState?.account_name}
                />)
            } else {
                return (
                    <CustomerDisclosurePDF
                        dealState={dealState}
                        customerName={customerName}
                        customerAddress={customerAddress}
                        companyName={profileState?.account_name}
                    />
                )
            }
        } else {
            if (dealState.is_purchase) {
                return (
                    <PurchaseDealerDisclosurePDF
                        dealState={dealState}
                        companyName={profileState?.account_name}
                    />
                )
            } else {
                return (
                    <DealerDisclosurePDF
                        dealState={dealState}
                        companyName={profileState?.account_name}
                    />
                )
            }
        }
    }

    return (
        <BaseModal
            isOpen={isOpen}
            setIsOpen={() => setIsOpen(null)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            style={style}
        >
            <Stack
                direction="column"
                alignItems="left"
                style={{
                    height: '100%',
                    padding: isTabletOrMobile ? '' : '30px 20px'
                }}
            >
                {
                    !isTabletOrMobile &&
                    <React.Fragment>
                        <Typography
                            gutterBottom
                            variant="h5"
                            component="div"
                            className={'DealRebateModal-name'}
                        >
                            {isCustomerPDF ? 'Customer ' : 'Dealer '} Worksheet
                        </Typography>
                        <Divider className={'divider'} />
                    </React.Fragment>
                }
                {
                    isCustomerPDF &&
                    <Stack
                        direction={isTabletOrMobile ? 'column' : 'row'}
                        justifyContent="space-between"
                        className={''}
                    >
                        <div>
                            <Input
                                className={'CustomerPDF-input'}
                                type="text"
                                variant="standard"
                                value={customerName}
                                placeholder={'Customer Name'}
                                onChange={(e) => setCustomerName(e.target.value)}
                            />
                        </div>
                        <div>
                            <Input
                                className={'CustomerPDF-input'}
                                placeholder={'Customer Address'}
                                variant="standard"
                                inputComponent={({inputRef, onFocus, onBlur, ...props}) => (
                                    <Autocomplete
                                        variant="standard"
                                        className={classnames('', {
                                            disabled: !customerAddress
                                        })}
                                        apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                                        {...props}
                                        onPlaceSelected={(place) => {
                                            setCustomerAddress(parseGoogleAddressData(place.address_components))
                                        }}
                                        options={{
                                            componentRestrictions: {country: ["us", "ca"]},
                                            fields: ["address_components", "geometry"],
                                            types: ["address"],
                                        }}
                                    />
                                )}
                            />
                        </div>
                    </Stack>
                }

                <Box
                    style={{
                        width: '100%',
                        height: '100%',
                        marginTop: isTabletOrMobile ? "" : '20px',
                    }}
                >

                    <PDFViewer
                        style={{
                            width: '100%',
                            height: '100%'
                        }}
                    >
                        {pdfDisclosure()}
                    </PDFViewer>
                </Box>
            </Stack>
        </BaseModal>
    )
}